export const COMPLETE_ONBOARDING_STEP = "COMPLETE_ONBOARDING_STEP";
export const RESET_ONBOARDING = "RESET_ONBOARDING";
